import Empty from "layouts/dashboards/empty";
import PageList from "layouts/pages/pages/list";
import WidgetList from "layouts/pages/widgets/list";
import PostTypeList from "layouts/pages/postTypes/list";
import PostList from "layouts/pages/posts/list";
import NewOrEditPage from "layouts/pages/pages/newOrEdit";
import NewOrEditPostType from "layouts/pages/postTypes/newOrEdit";
import NewOrEditPost from "layouts/pages/posts/newOrEdit";
import EditPopup from "layouts/pages/widgets/popups";
import EditBanner from "layouts/pages/widgets/banners";
import AdminUserList from "layouts/pages/adminUsers/list";
import AdminUserSettings from "layouts/pages/adminUsers/settings";
import UserList from "layouts/pages/users/list";
import NewOrEditAdminUser from "layouts/pages/adminUsers/newOrEdit";
import NewOrEditUser from "layouts/pages/users/newOrEdit";
import MediaLibrary from "layouts/pages/media-lib";
import MediaLibraryUpload from "layouts/pages/media-lib/upload";
// import Import from "layouts/pages/import";

import Dashboard from "examples/Icons/Dashboard";
import User from "examples/Icons/User";
import Image from "examples/Icons/Image";
import Rss from "examples/Icons/Rss";

import SignInCover from "layouts/authentication/sign-in/cover";

const routes = [
  {
    type: "link",
    name: "Home Page",
    key: "dashboard",
    route: "/dashboard",
    icon: <Dashboard size="12px" />,
    component: Empty,
  },
  {
    type: "link",
    name: "Page",
    key: "pages",
    route: "/pages",
    icon: <Image size="12px" />,
    component: PageList,
    accesses: [
      {
        role: "admin",
        department: "admin",
        mode: "admin",
      },
      {
        role: "manager",
        department: "marketing",
        mode: "view",
      },
      {
        role: "staff",
        department: "marketing",
        mode: "view",
      },
      {
        role: "manager",
        department: "it",
        mode: "admin",
      },
      {
        role: "staff",
        department: "it",
        mode: "admin",
      },
      {
        role: "manager",
        department: "cs",
        mode: "view",
      },
      {
        role: "staff",
        department: "cs",
        mode: "view",
      },
    ],
  },
  {
    type: "link",
    name: "Post Types",
    key: "post-types",
    route: "/post-types",
    icon: <Rss size="12px" />,
    component: PostTypeList,
    accesses: [
      {
        role: "admin",
        department: "admin",
        mode: "admin",
      },
      {
        role: "manager",
        department: "marketing",
        mode: "view",
      },
      {
        role: "staff",
        department: "marketing",
        mode: "view",
      },
      {
        role: "manager",
        department: "it",
        mode: "admin",
      },
      {
        role: "staff",
        department: "it",
        mode: "admin",
      },
      {
        role: "manager",
        department: "cs",
        mode: "view",
      },
      {
        role: "staff",
        department: "cs",
        mode: "view",
      },
    ],
  },
  {
    type: "hidden",
    name: "Posts",
    key: "posts",
    route: "/post-types/:postTypeId/posts",
    icon: <Rss size="12px" />,
    component: PostList,
    accesses: [
      {
        role: "admin",
        department: "admin",
        mode: "admin",
      },
      {
        role: "manager",
        department: "marketing",
        mode: "admin",
      },
      {
        role: "staff",
        department: "marketing",
        mode: "admin",
      },
      {
        role: "manager",
        department: "it",
        mode: "admin",
      },
      {
        role: "staff",
        department: "it",
        mode: "admin",
      },
      {
        role: "manager",
        department: "cs",
        mode: "view",
      },
      {
        role: "staff",
        department: "cs",
        mode: "view",
      },
    ],
  },
  {
    type: "link",
    name: "Widget",
    key: "widgets",
    route: "/widgets",
    icon: <Image size="12px" />,
    component: WidgetList,
    accesses: [
      {
        role: "admin",
        department: "admin",
        mode: "admin",
      },
      {
        role: "manager",
        department: "marketing",
        mode: "view",
      },
      {
        role: "staff",
        department: "marketing",
        mode: "view",
      },
      {
        role: "manager",
        department: "it",
        mode: "admin",
      },
      {
        role: "staff",
        department: "it",
        mode: "admin",
      },
      {
        role: "manager",
        department: "cs",
        mode: "view",
      },
      {
        role: "staff",
        department: "cs",
        mode: "view",
      },
    ],
  }, 
  {
    type: "link",
    name: "Users",
    key: "Users",
    route: "/users",
    icon: <User size="12px" />,
    component: UserList,
    accesses: [
      {
        role: "admin",
        department: "admin",
        mode: "admin",
      },
      {
        role: "manager",
        department: "marketing",
        mode: "view",
      },
      {
        role: "staff",
        department: "marketing",
        mode: "view",
      },
      {
        role: "manager",
        department: "it",
        mode: "admin",
      },
      {
        role: "staff",
        department: "it",
        mode: "view",
      },
      {
        role: "manager",
        department: "cs",
        mode: "admin",
      },
      {
        role: "staff",
        department: "cs",
        mode: "admin",
      },
    ],
  },
  {
    type: "link",
    name: "Media Library",
    key: "media-library",
    route: "/media-library",
    icon: <Image size="12px" />,
    component: MediaLibrary,    
    accesses: [
      {
        role: "admin",
        department: "admin",
        mode: "admin",
      },
      {
        role: "manager",
        department: "marketing",
        mode: "admin",
      },
      {
        role: "staff",
        department: "marketing",
        mode: "admin",
      },
      {
        role: "manager",
        department: "it",
        mode: "admin",
      },
      {
        role: "staff",
        department: "it",
        mode: "admin",
      },
      {
        role: "manager",
        department: "cs",
        mode: "view",
      },
      {
        role: "staff",
        department: "cs",
        mode: "view",
      },
    ],    
  },
  // {
  //   type: "link",
  //   name: "Import",
  //   key: "import-word",
  //   route: "/import-word",
  //   icon: <Upload size="12px" />,
  //   component: Import,
  // },
  // {
  //   type: "link",
  //   name: "PDF",
  //   key: "import-pdf",
  //   route: "/import-pdf",
  //   icon: <Upload size="12px" />,
  //   component: Import,
  // },
  // {
  //   type: "link",
  //   name: "Settings",
  //   key: "settings",
  //   route: "/settings",
  //   icon: <Settings size="12px" />,
  //   component: Profile,
  // },
  {
    type: "hidden",
    name: "New Page",
    key: "new-page",
    route: "/pages/new",
    component: NewOrEditPage,
    accesses: [
      {
        role: "admin",
        department: "admin",
        mode: "admin",
      },
      {
        role: "manager",
        department: "it",
        mode: "admin",
      },
      {
        role: "staff",
        department: "it",
        mode: "admin",
      },
    ],
  },
  {
    type: "hidden",
    name: "Edit Page",
    key: "edit-page",
    route: "/pages/edit/:id",
    component: NewOrEditPage,
    accesses: [
      {
        role: "admin",
        department: "admin",
        mode: "admin",
      },
      {
        role: "manager",
        department: "marketing",
        mode: "view",
      },
      {
        role: "staff",
        department: "marketing",
        mode: "view",
      },
      {
        role: "manager",
        department: "it",
        mode: "admin",
      },
      {
        role: "staff",
        department: "it",
        mode: "admin",
      },
      {
        role: "manager",
        department: "cs",
        mode: "view",
      },
      {
        role: "staff",
        department: "cs",
        mode: "view",
      },
    ],
  },
  {
    type: "hidden",
    name: "New Post Type",
    key: "new-post-type",
    route: "/post-types/new",
    component: NewOrEditPostType,
    accesses: [
      {
        role: "admin",
        department: "admin",
        mode: "admin",
      },
      {
        role: "manager",
        department: "marketing",
        mode: "view",
      },
      {
        role: "staff",
        department: "marketing",
        mode: "view",
      },
      {
        role: "manager",
        department: "it",
        mode: "admin",
      },
      {
        role: "staff",
        department: "it",
        mode: "admin",
      },
      {
        role: "manager",
        department: "cs",
        mode: "view",
      },
      {
        role: "staff",
        department: "cs",
        mode: "view",
      },
    ],
  },
  {
    type: "hidden",
    name: "Edit Post Type",
    key: "edit-post-type",
    route: "/post-types/edit/:id",
    component: NewOrEditPostType,
    accesses: [
      {
        role: "admin",
        department: "admin",
        mode: "admin",
      },
      {
        role: "manager",
        department: "marketing",
        mode: "view",
      },
      {
        role: "staff",
        department: "marketing",
        mode: "view",
      },
      {
        role: "manager",
        department: "it",
        mode: "admin",
      },
      {
        role: "staff",
        department: "it",
        mode: "admin",
      },
      {
        role: "manager",
        department: "cs",
        mode: "view",
      },
      {
        role: "staff",
        department: "cs",
        mode: "view",
      },
    ],
  },
  {
    type: "hidden",
    name: "Posts",
    key: "posts",
    route: "/post-types/:postTypeId/posts/new",
    icon: <Rss size="12px" />,
    component: NewOrEditPost,
    accesses: [
      {
        role: "admin",
        department: "admin",
        mode: "admin",
      },
      {
        role: "manager",
        department: "marketing",
        mode: "admin",
      },
      {
        role: "staff",
        department: "marketing",
        mode: "admin",
      },
      {
        role: "manager",
        department: "it",
        mode: "admin",
      },
      {
        role: "staff",
        department: "it",
        mode: "admin",
      },
      {
        role: "manager",
        department: "cs",
        mode: "view",
      },
      {
        role: "staff",
        department: "cs",
        mode: "view",
      },
    ],
  },
  {
    type: "hidden",
    name: "Posts",
    key: "posts",
    route: "/post-types/:postTypeId/posts/edit/:id",
    icon: <Rss size="12px" />,
    component: NewOrEditPost,
    accesses: [
      {
        role: "admin",
        department: "admin",
        mode: "admin",
      },
      {
        role: "manager",
        department: "marketing",
        mode: "admin",
      },
      {
        role: "staff",
        department: "marketing",
        mode: "admin",
      },
      {
        role: "manager",
        department: "it",
        mode: "admin",
      },
      {
        role: "staff",
        department: "it",
        mode: "admin",
      },
      {
        role: "manager",
        department: "cs",
        mode: "view",
      },
      {
        role: "staff",
        department: "cs",
        mode: "view",
      },
    ],
  },
  {
    type: "hidden",
    name: "Edit Popups",
    key: "edit-popups",
    route: "/widgets/popups",
    component: EditPopup,
    accesses: [
      {
        role: "admin",
        department: "admin",
        mode: "admin",
      },
      {
        role: "manager",
        department: "marketing",
        mode: "admin",
      },
      {
        role: "staff",
        department: "marketing",
        mode: "admin",
      },
      {
        role: "manager",
        department: "it",
        mode: "admin",
      },
      {
        role: "staff",
        department: "it",
        mode: "admin",
      },
      {
        role: "manager",
        department: "cs",
        mode: "view",
      },
      {
        role: "staff",
        department: "cs",
        mode: "view",
      },
    ],
  },
  {
    type: "hidden",
    name: "Edit Banners",
    key: "edit-banners",
    route: "/widgets/banners",
    component: EditBanner,
    accesses: [
      {
        role: "admin",
        department: "admin",
        mode: "admin",
      },
      {
        role: "manager",
        department: "marketing",
        mode: "admin",
      },
      {
        role: "staff",
        department: "marketing",
        mode: "admin",
      },
      {
        role: "manager",
        department: "it",
        mode: "admin",
      },
      {
        role: "staff",
        department: "it",
        mode: "admin",
      },
      {
        role: "manager",
        department: "cs",
        mode: "view",
      },
      {
        role: "staff",
        department: "cs",
        mode: "view",
      },
    ],
  },
  {
    type: "hidden",
    name: "Create Admin User",
    key: "new-adminUsers",
    route: "/adminUsers/new",
    component: NewOrEditAdminUser,
    accesses: [      
      {
        role: "admin",
        department: "admin",
        mode: "admin",
      },
      {
        role: "staff",
        department: "admin",
        mode: "admin",
      },
      {
        role: "manager",
        department: "admin",
        mode: "admin",
      },
      {
        role: "manager",
        department: "marketing",
        mode: "view",
      },
      {
        role: "staff",
        department: "marketing",
        mode: "view",
      },
      {
        role: "manager",
        department: "it",
        mode: "admin",
      },
      {
        role: "staff",
        department: "it",
        mode: "admin",
      },
      {
        role: "manager",
        department: "cs",
        mode: "admin",
      },
      {
        role: "staff",
        department: "cs",
        mode: "admin",
      },
    ],

  },
  {
    type: "hidden",
    name: "Edit Admin User",
    key: "edit-adminUser",
    route: "/adminUsers/edit/:id",
    component: NewOrEditAdminUser,
    accesses: [
      {
        role: "admin",
        department: "admin",
        mode: "admin",
      },
      {
        role: "staff",
        department: "admin",
        mode: "admin",
      },
      {
        role: "manager",
        department: "admin",
        mode: "admin",
      },
      {
        role: "manager",
        department: "marketing",
        mode: "view",
      },
      {
        role: "staff",
        department: "marketing",
        mode: "view",
      },
      {
        role: "manager",
        department: "it",
        mode: "admin",
      },
      {
        role: "staff",
        department: "it",
        mode: "admin",
      },
      {
        role: "manager",
        department: "cs",
        mode: "admin",
      },
      {
        role: "staff",
        department: "cs",
        mode: "admin",
      },
    ],
  },

  {
    type: "hidden",
    name: "Create User",
    key: "new-Users",
    route: "/users/new",
    component: NewOrEditUser,
    accesses: [
      {
        role: "admin",
        department: "admin",
        mode: "admin",
      },
      {
        role: "manager",
        department: "marketing",
        mode: "view",
      },
      {
        role: "staff",
        department: "marketing",
        mode: "view",
      },
      {
        role: "manager",
        department: "it",
        mode: "admin",
      },
      {
        role: "staff",
        department: "it",
        mode: "view",
      },
      {
        role: "manager",
        department: "cs",
        mode: "admin",
      },
      {
        role: "staff",
        department: "cs",
        mode: "admin",
      },
    ],
  },
  {
    type: "hidden",
    name: "Edit User",
    key: "edit-User",
    route: "/users/edit/:id",
    component: NewOrEditUser,
    accesses: [
      {
        role: "admin",
        department: "admin",
        mode: "admin",
      },
      {
        role: "manager",
        department: "marketing",
        mode: "view",
      },
      {
        role: "staff",
        department: "marketing",
        mode: "view",
      },
      {
        role: "manager",
        department: "it",
        mode: "admin",
      },
      {
        role: "staff",
        department: "it",
        mode: "view",
      },
      {
        role: "manager",
        department: "cs",
        mode: "admin",
      },
      {
        role: "staff",
        department: "cs",
        mode: "admin",
      },
    ],
  },
  {
    type: "hidden",
    name: "Media Library Upload",
    key: "media-library-upload",
    route: "/media-library/upload",
    component: MediaLibraryUpload,
    accesses: [
      {
        role: "admin",
        department: "admin",
        mode: "admin",
      },
      {
        role: "manager",
        department: "marketing",
        mode: "admin",
      },
      {
        role: "staff",
        department: "marketing",
        mode: "admin",
      },
      {
        role: "manager",
        department: "it",
        mode: "admin",
      },
      {
        role: "staff",
        department: "it",
        mode: "admin",
      },
      {
        role: "manager",
        department: "cs",
        mode: "view",
      },
      {
        role: "staff",
        department: "cs",
        mode: "view",
      },
    ],  
  },
  {
    type: "collapse",
    name: "Settings",
    key: "settings-root",
    collapse: [
      {
        name: "Admin Users",
        key: "admin-users",
        route: "/adminUsers",
        component: AdminUserList,
        accesses: [
          {
            role: "admin",
            department: "admin",
            mode: "admin",
          },
          {
            role: "manager",
            department: "marketing",
            mode: "view",
          },
          {
            role: "staff",
            department: "marketing",
            mode: "view",
          },
          {
            role: "manager",
            department: "it",
            mode: "admin",
          },
          {
            role: "staff",
            department: "it",
            mode: "admin",
          },
          {
            role: "manager",
            department: "cs",
            mode: "admin",
          },
          {
            role: "staff",
            department: "cs",
            mode: "admin",
          },
        ],
      },
      {
        name: "Settings",
        key: "settings",
        route: "/settings",
        component: AdminUserSettings,
      },
    ],
  },
  {
    type: "hidden",
    name: "Sign In",
    key: "sign-in",
    collapse: [
      {
        name: "Sign In",
        key: "sign-in",
        collapse: [
          {
            name: "Cover",
            key: "cover",
            route: "/sign-in",
            component: SignInCover,
          },
        ],
      },
    ],
  },
];

export default routes;

export const mode = (route, role, dept) => {
  let result;
  if (role === "admin") {
    result = "admin";
  } else if (route.accesses) {
    result = false;
    const access = route.accesses.find((a) => a.role === role && a.department === dept);
    if (access) {
      result = access.mode;
    }
  }
  return result;
};
